import { proxy } from 'valtio';
import { VeevaFatalErrorsStateType } from 'basics/types/maya.types';

const veevaFatalErrorsState = proxy<VeevaFatalErrorsStateType>({
  hasErrors: false,
});

export default veevaFatalErrorsState;
